import { UsersRepository, AppInstancesRepository, DevicesRepository } from 'common/repositories/index';

const _serviceDependencies = ['AppInstanceRestService', 'DeviceRestService', '$q',
    'UserRestService'];

/**
 * @ngdoc service
 * @name rest.services.DeployRestService
 *
 * @description
 * This class contains methods used to deploy instances on devices
 * using http requests.
*/
export default class DeployRestService {

    /**
     * @param  {any} AppInstanceRestService
     */
    constructor(AppInstanceRestService, DeviceRestService, $q, UserRestService) {

        this.AppInstanceRestService = AppInstanceRestService;
        this.DeviceRestService = DeviceRestService;
        this.UserRestService = UserRestService;
        this.UsersRepository = UsersRepository;
        this.DevicesRepository = DevicesRepository;
        this.AppInstancesRepository = AppInstancesRepository;
        this.$q = $q;

    }

    deployOnNewDevice(data) {

        const deployDeferred = this.$q.defer();
        const devicePayload = {
            data: {
                attributes: {
                    state: 'pending',
                    os: data.os,
                    type: ['android', 'ios'].indexOf(data.os.toLowerCase()) > -1 ? 'phone' : 'pc',
                    os_type: data.os_type,
                },
                relationships: {
                    user: {
                        data: {
                            id: data.userId,
                            type: 'users',
                        },
                    },
                },
            },
        };

        this.DeviceRestService.create(devicePayload)
            .then((device) => {

                this.DevicesRepository.add(device.data.data);

                this.deployOnDevice({
                    userId: data.userId,
                    appId: data.appId,
                    deviceId: device.data.data.id,
                    licenseId: data.licenseId,
                    os_type: data.os_type,
                    meta: data.meta || {},
                })
                    .then((appInstance) => {

                        deployDeferred.resolve(appInstance);

                    })
                    .then(null, (err) => {

                        deployDeferred.reject(err);

                    });

            })
            .then(null, (err) => {

                deployDeferred.reject(err);

            });

        return deployDeferred.promise;

    }

    deployOnDevice(data) {

        const relationshipsObj = {
            device: {
                data: {
                    type: 'devices',
                    id: data.deviceId,
                },
            },
            user: {
                data: {
                    type: 'users',
                    id: data.userId,
                },
            },
            app: {
                data: {
                    type: 'apps',
                    id: data.appId,
                },
            },
        };

        if (data.licenseId) {

            relationshipsObj.license = {
                data: {
                    type: 'license',
                    id: data.licenseId,
                },
            };

        }

        const deploymentPayload = {
            data: {
                relationships: relationshipsObj,
                attributes: {
                    download_source: 'wd',
                    state: 'pending',
                },
                type: 'app-instances',
            },
            meta: data.meta || {},
        };

        return this.AppInstanceRestService
            .create(deploymentPayload)
            .then((response) => {

                if (angular.isArray(response.data.data)) {

                    response.data.data.forEach((instance) => {

                        this.AppInstancesRepository.add(instance);

                    });

                } else {

                    this.AppInstancesRepository.add(response.data.data);

                }

                return response.data;

            });

    }

}

_serviceDependencies.push(DeployRestService);

angular.module('rest.services')
    .service('DeployRestService', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/restServices/deployRestService.js